<template>
  <div class="new-user-wrapper">
    <div class="hero-section">
      <div class="hero-content">
        <h1 class="hero-title">
          <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor">
            <path
                d="M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zm-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180zm48 68h250v308H228V550zm568 308H546V550h250v308zm48-376H546V378h298v104z"></path>
          </svg>
          新人专享优惠
        </h1>
        <div class="hero-subtitle">新用户专享优惠，限时特价，错过不再有！</div>
        <span class="hero-tag">
          <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor">
            <path
                d="M834.1 469.2A347.49 347.49 0 00751.2 354l-29.1-26.7a8.09 8.09 0 00-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 01-47.5 46.1 352.6 352.6 0 00-100.3 121.5A347.75 347.75 0 00160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0075.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 00760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0027.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0058.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0012.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0024.4 59.8 73.36 73.36 0 0053.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z"></path>
          </svg>
          限时优惠，仅限新用户
        </span>
      </div>
      <div class="content-wrapper">
        <div class="section-card">
          <div class="section-body">
            <h2 class="section-title">专享优惠套餐</h2>
            <div class="packages-grid">
              <div v-for="pkg in packages" :key="pkg.id" class="package-card" :class="{ 'package-featured': pkg.badge }"
                   :style="{ borderColor: pkg.borderColor }">
                <div v-if="pkg.badge" class="package-badge" :style="{ background: pkg.buttonBg }">
                  {{ pkg.badge }}
                </div>
                <div class="package-body">
                  <div class="package-header">
                    <div class="package-icon" :style="{ background: pkg.iconBg }">
                      <span role="img" aria-label="tool">
                        <svg viewBox="64 64 896 896" focusable="false" data-icon="tool" width="1em" height="1em"
                             fill="currentColor" aria-hidden="true">
                          <path
                              d="M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 01144-53.5L537 318.9a32.05 32.05 0 000 45.3l124.5 124.5a32.05 32.05 0 0045.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z"></path>
                        </svg>
                      </span>
                    </div>
                    <h3 class="package-title">{{ pkg.title }}</h3>
                    <span class="package-desc">{{ pkg.desc }}</span>
                  </div>
                  <div class="package-price">
                    <div class="price-original">{{ pkg.originalPrice }}</div>
                    <div class="price-current">{{ pkg.price }}</div>
                    <span class="price-discount">{{ pkg.discount }}</span>
                  </div>
                  <ul class="package-features">
                    <li v-for="feature in pkg.features" :key="feature" class="feature-item">
                      <span role="img" aria-label="check-circle" class="feature-icon">
                        <svg viewBox="64 64 896 896" focusable="false" data-icon="check-circle" width="1em" height="1em"
                             fill="currentColor" aria-hidden="true">
                          <path
                              d="M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"></path>
                          <path
                              d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
                        </svg>
                      </span>
                      <span>{{ feature }}</span>
                    </li>
                  </ul>
                  <button type="button" class="package-button" :style="{ background: pkg.buttonBg, borderColor: pkg.buttonBg }">
                    <span>立即抢购</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section-card">
          <div class="section-body">
            <h2 class="section-title">为什么选择智维驿？</h2>
            <div class="features-grid">
              <div v-for="feature in features" :key="feature.id" class="feature-card">
                <div class="feature-icon-wrapper" :style="{ color: feature.iconColor }">
                  <span role="img" aria-label="user">
                    <svg viewBox="64 64 896 896" focusable="false" data-icon="user" width="1em" height="1em"
                         fill="currentColor" aria-hidden="true">
                      <path
                          d="M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"></path>
                    </svg>
                  </span>
                </div>
                <h4 class="feature-title">{{ feature.title }}</h4>
                <span class="feature-desc">{{ feature.desc }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="section-card">
          <div class="section-body">
            <h2 class="section-title">用户真实评价</h2>
            <div class="reviews-grid">
              <div v-for="review in reviews" :key="review.id" class="review-card">
                <div class="review-body">
                  <div class="review-header">
                    <span class="review-avatar">
                      <span role="img" aria-label="user">
                        <svg viewBox="64 64 896 896" focusable="false" data-icon="user" width="1em" height="1em"
                             fill="currentColor" aria-hidden="true">
                          <path
                              d="M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"></path>
                        </svg>
                      </span>
                    </span>
                    <div class="review-user-info">
                      <span class="review-name"><strong>{{ review.name }}</strong></span>
                      <div><span class="review-tag">{{ review.tag }}</span></div>
                    </div>
                  </div>
                  <div class="review-rating">
                    <span v-for="i in review.rating" :key="i" role="img" aria-label="star" class="star-icon">
                      <svg viewBox="64 64 896 896" focusable="false" data-icon="star" width="1em" height="1em"
                           fill="currentColor" aria-hidden="true">
                        <path
                            d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"></path>
                      </svg>
                    </span>
                  </div>
                  <span class="review-content">{{ review.content }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section-card">
          <div class="section-body">
            <h2 class="section-title">智维驿服务数据</h2>
            <div class="statistics-grid">
              <div v-for="stat in statistics" :key="stat.id" class="statistic-item">
                <div class="statistic-title">{{ stat.title }}</div>
                <div class="statistic-content" :style="{ color: stat.color }">
                  <span class="statistic-value">
                    <span class="statistic-value-int">{{ stat.value }}</span>
                    <span v-if="stat.decimal" class="statistic-value-decimal">{{ stat.decimal }}</span>
                  </span>
                  <span class="statistic-suffix">{{ stat.suffix }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.new-user-wrapper {
  background: #f5f6fa;
}

.hero-section {
  background: linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%);
  padding: 3rem 0;
  margin-bottom: 2rem;
}

.hero-content {
  width: 75rem;
  margin: 0 auto;
  padding: 0 1.5rem;
  text-align: center;
  color: white;
}

.hero-title {
  color: white;
  margin-bottom: 1rem;
  font-size: 2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}

.hero-subtitle {
  color: white;
  font-size: 1.125rem;
  margin-bottom: 0.5rem;
}

.hero-tag {
  font-size: 1rem;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0.25rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.content-wrapper {
  width: 75rem;
  margin: 0 auto;
  padding: 0 1.5rem;
}

/* 通用卡片样式 */
.section-card {
  background: #fff;
  border-radius: 0.75rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.section-body {
  padding: 1.5rem;
}

.section-title {
  text-align: center;
  margin-bottom: 2rem;
  font-size: 1.5rem;
  font-weight: 600;
}

/* 套餐网格 */
.packages-grid {
  display: flex;
  flex-wrap: nowrap;
  gap: 1.5rem;
}

.package-card {
  flex: 1;
  background: #fff;
  border-radius: 0.75rem;
  border: 0.125rem solid;
  position: relative;
  overflow: hidden;
  height: 100%;
}

.package-featured {
  border-width: 0.125rem;
}

.package-badge {
  position: absolute;
  top: 0;
  right: 0;
  color: white;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  border-radius: 0 0.75rem 0 0.5rem;
}

.package-body {
  padding: 1.5rem;
}

.package-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.package-icon {
  width: 3.75rem;
  height: 3.75rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  color: white;
  font-size: 1.5rem;
}

.package-title {
  margin: 0 0 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
}

.package-desc {
  font-size: 0.875rem;
  color: #666;
}

.package-price {
  text-align: center;
  margin-bottom: 1.5rem;
}

.price-original {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  color: #999;
  text-decoration: line-through;
}

.price-current {
  margin-bottom: 0.5rem;
  font-size: 2rem;
  font-weight: bold;
  color: rgb(245, 34, 45);
  text-shadow: 0 0.125rem 0.375rem rgba(245, 34, 45, 0.4);
}

.price-discount {
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
  background: rgb(255, 77, 79);
  color: white;
  border-radius: 0.25rem;
}

.package-features {
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem;
}

.feature-item {
  padding: 0.25rem 0;
  border: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.feature-icon {
  color: rgb(82, 196, 26);
  flex-shrink: 0;
}

.package-button {
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  font-size: 1rem;
  width: 100%;
  border: none;
  color: #fff;
}

.package-button:hover {
  transform: translateY(-0.125rem);
  box-shadow: 0 0.375rem 1rem rgba(0, 0, 0, 0.2);
}

.package-button:active {
  transform: translateY(0);
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.15);
}

/* 特性网格 */
.features-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.feature-card {
  flex: 1;
  width: 12.5rem;
  text-align: center;
}

.feature-icon-wrapper {
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.feature-title {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
}

.feature-desc {
  font-size: 0.875rem;
  color: #666;
}

/* 评价网格 */
.reviews-grid {
  display: flex;
  flex-wrap: nowrap;
  gap: 1.5rem;
}

.review-card {
  flex: 1;
  background: #fff;
  border-radius: 0.75rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.1);
  height: 100%;
}

.review-body {
  padding: 1.5rem;
}

.review-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.review-avatar {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  flex-shrink: 0;
}

.review-user-info {
  margin-left: 0.75rem;
}

.review-name {
  display: block;
  font-size: 1rem;
}

.review-tag {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  background: rgb(24, 144, 255);
  color: white;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  margin-top: 0.25rem;
}

.review-rating {
  margin-bottom: 0.75rem;
}

.star-icon {
  color: rgb(250, 173, 20);
  margin-right: 0.25rem;
}

.review-content {
  font-size: 0.875rem;
  color: #666;
  line-height: 1.5;
}

/* 统计数据网格 */
.statistics-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.statistic-item {
  flex: 1;
  width: 12.5rem;
  text-align: center;
}

.statistic-title {
  font-size: 0.875rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.statistic-content {
  font-size: 1.5rem;
  font-weight: 600;
}

.statistic-value {
  font-size: 1.5rem;
}

.statistic-value-decimal {
  font-size: 1rem;
}

.statistic-suffix {
  margin-left: 0.25rem;
}
</style>
<script setup>
import { ref } from 'vue'

// 套餐数据
const packages = ref([
  {
    id: 1,
    title: '慧维修新人专享',
    desc: '专业设备维修服务，新用户专享优惠',
    originalPrice: '¥299',
    price: '¥99',
    discount: '立省67%',
    badge: '最受欢迎',
    iconBg: 'rgb(24, 144, 255)',
    borderColor: 'rgb(24, 144, 255)',
    buttonBg: 'rgb(24, 144, 255)',
    features: [
      '专业工程师上门服务',
      '免费故障检测',
      '90天质保期',
      '透明报价无隐形收费',
      '24小时响应'
    ]
  },
  {
    id: 2,
    title: '慧租赁体验套餐',
    desc: '智能设备租赁服务，体验价仅限新用户',
    originalPrice: '¥199',
    price: '¥59',
    discount: '立省70%',
    badge: null,
    iconBg: 'rgb(82, 196, 26)',
    borderColor: 'rgb(240, 240, 240)',
    buttonBg: 'rgb(82, 196, 26)',
    features: [
      '设备免费配送安装',
      '7天免费试用',
      '专业技术支持',
      '灵活租期选择',
      '设备保险保障'
    ]
  },
  {
    id: 3,
    title: '慧管理入门包',
    desc: '设备管理解决方案，助力企业数字化转型',
    originalPrice: '¥399',
    price: '¥129',
    discount: '立省68%',
    badge: null,
    iconBg: 'rgb(114, 46, 209)',
    borderColor: 'rgb(240, 240, 240)',
    buttonBg: 'rgb(114, 46, 209)',
    features: [
      '设备全生命周期管理',
      '智能预警系统',
      '数据分析报告',
      '7×24小时监控',
      '专业培训支持'
    ]
  }
])

// 特性数据
const features = ref([
  {
    id: 1,
    title: '专业团队',
    desc: '资深工程师团队，平均5年以上经验',
    iconColor: 'rgb(24, 144, 255)'
  },
  {
    id: 2,
    title: '快速响应',
    desc: '24小时内响应，48小时内完成服务',
    iconColor: 'rgb(82, 196, 26)'
  },
  {
    id: 3,
    title: '质量保证',
    desc: '服务不满意，先行赔付，无后顾之忧',
    iconColor: 'rgb(250, 173, 20)'
  },
  {
    id: 4,
    title: '全国覆盖',
    desc: '覆盖全国300+城市，就近服务',
    iconColor: 'rgb(245, 34, 45)'
  }
])

// 评价数据
const reviews = ref([
  {
    id: 1,
    name: '张先生',
    tag: '慧维修',
    rating: 5,
    content: '新人专享价格很实惠，服务也很专业，工程师技术很好，问题解决得很快！'
  },
  {
    id: 2,
    name: '李女士',
    tag: '慧租赁',
    rating: 5,
    content: '第一次使用智维驿的服务，体验很棒，价格透明，没有额外收费。'
  },
  {
    id: 3,
    name: '王经理',
    tag: '慧管理',
    rating: 5,
    content: '公司设备管理一直是个难题，慧管理帮我们解决了大问题，效率提升明显。'
  }
])

// 统计数据
const statistics = ref([
  {
    id: 1,
    title: '服务用户',
    value: '50,000',
    suffix: '+',
    color: 'rgb(24, 144, 255)'
  },
  {
    id: 2,
    title: '服务订单',
    value: '150,000',
    suffix: '+',
    color: 'rgb(82, 196, 26)'
  },
  {
    id: 3,
    title: '服务城市',
    value: '300',
    suffix: '+',
    color: 'rgb(250, 173, 20)'
  },
  {
    id: 4,
    title: '满意度',
    value: '98',
    decimal: '.5',
    suffix: '%',
    color: 'rgb(245, 34, 45)'
  }
])
</script>